import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyState = ({ 
  icon: Icon = Inbox, 
  title = 'Sin datos', 
  description, 
  action 
}) => (
  <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
    <div className="w-16 h-16 bg-slate-700/50 rounded-2xl flex items-center justify-center mb-4">
      <Icon size={32} className="text-slate-500" />
    </div>
    <h3 className="text-lg font-semibold text-white mb-2">{title}</h3>
    {description && <p className="text-slate-400 mb-4 max-w-md">{description}</p>}
    {action}
  </div>
);

export default EmptyState;
